import { combineReducers } from 'redux';
import clientReducer from './slices/client';
import questionReducer from './slices/question';
import learnerReducer from './slices/learner';
import coursesReducer from './slices/courses';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const reducer = combineReducers({
    cart: persistReducer(
        {
            key: 'data',
            storage,
            keyPrefix: 'acsf-quiz-'
        },
        clientReducer
    ),
    client: clientReducer,
    question: questionReducer,
    learner: learnerReducer,
    courses: coursesReducer
});

export default reducer;
